<template>
  <div>
    <div style="height: 60px; display: flex; align-items: center">
      <el-input prefix-icon="el-icon-search" clearable v-model="searchText"
                style="margin-left: 10px; width: 220px"></el-input>
      <div class="block" style="margin-left: 10px;">
        <el-date-picker v-model="taskTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            :picker-options="pickerOptions" @change="DatetimeListTap" style="width:350px">
        </el-date-picker>
      </div>
      <search-popover style="margin-left: 10px">
        <el-button slot="reference" icon="el-icon-search" style="margin-right: 10px">搜索</el-button>
      </search-popover>
      <el-button v-ADD_WORK @click="addWork" icon="el-icon-plus" type="primary">新增工单
      </el-button>
      <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <div style="flex-grow: 1"></div><!-- flex 占位 -->
      <div v-if="OPsearchShow">
          <el-switch style="display: block" v-model="newSearchShow" active-color="#409EFF" inactive-color="#409EFF"
            active-text="全部" inactive-text="个人" @change="searchTap">
          </el-switch>
      </div>
      <statistics-kanban :value="statistics"></statistics-kanban>
    </div>

    <div style="overflow-x: auto;" v-if="$store.state.work.loaded">
      <!--<el-scrollbar v-if="$store.state.work.loaded">-->
      <div style="display: flex; background-color: #ebecf0" :style="mainViewStyle">

        <div style="margin-right: 4px;" :style="mainViewColumnStyle">
          <work-title v-if="beginWork" :title="beginWork.name" :height="56" :num="beginWork.workList.length">
          </work-title>
          <div style="height: 4px"></div>
          <div v-if="beginWork" style="overflow-y: overlay; background-color: white;"
               :style="{'height': contentHeight()}">
            <!--<el-scrollbar v-if="beginWork" style="background-color: white; height: calc(100vh - 188px)">-->
            <transition-group name="list-complete">
              <work-card v-for="work in beginWork.workList" :key="work.id"
                         :work="work" :menu="selectMenuByWork(work)"
                         @command="handleWorkCardCommand"
                         class="card list-complete-item" :style="{'width': columnWidth + 'px'}">
              </work-card>
            </transition-group>
            <!--</el-scrollbar>-->
          </div>
        </div>

        <div style="width: 24px; margin-top: 60px;">
          <div
            style="height: calc(50% - 5px); background-color: #136598; display: flex; align-items: center;">
            <div style="margin-left: 4px; color: #f6f6f6">在修
            </div>
          </div>
          <div style="height: 10px"></div>
          <div style="height: calc(50% - 5px); background-color: #136598; display: flex; align-items: center">
            <div style="margin-left: 4px; color: #f6f6f6">等待</div>
          </div>
        </div>

        <div style="margin-right: 4px;" :style="mainViewColumnStyle"
             v-for="item in middleWorks" :key="item.name">
          <work-title :title="item[0].name"
                      :height="56"
                      :num="item[0].workList.length"
                      :wait-num="item[1] ? item[1].workList.length : undefined"
                      style="margin-bottom: 4px">
          </work-title>

          <div>

            <div class="boxScroll" style="overflow-y: overlay; background-color: white;"
                 :style="{'height': contentHeight(item[1])}">
              <!--<el-scrollbar style="background-color: white;"-->
              <!--:style="{'height': item[1] ? 'calc(50vh - 99px)' : 'calc(100vh - 188px)'}">-->
              <transition-group name="list-complete">
                <work-card v-for="work in item[0].workList" :key="work.id"
                           :work="work"
                           :menu="selectMenuByWork(work)"
                           :schshow="newSearchShow"
                           @command="handleWorkCardCommand"
                           class="card list-complete-item" :style="{'width': columnWidth + 'px'}">
                </work-card>
              </transition-group>
              <!--</el-scrollbar>-->
            </div>

            <div v-if="item[1]" style="height: 10px"></div>

            <div class="boxScroll" v-if="item[1]" style="overflow-y: overlay; background-color: white;"
                 :style="{'height': contentHeight2(true)}">
              <!--<el-scrollbar v-if="item[1]" style="height: calc(50vh - 99px); background-color: white;">-->
              <transition-group name="list-complete">
                <work-card v-for="work in item[1].workList" :key="work.id"
                           :work="work" :menu="selectMenuByWork(work)" :schshow="newSearchShow"
                           @command="handleWorkCardCommand($event, item[0].name)"
                           class="card list-complete-item" :style="{'width': columnWidth + 'px'}">
                </work-card>
              </transition-group>
              <!--</el-scrollbar>-->
            </div>

          </div>
        </div>

        <div style="margin-right: 4px;" :style="mainViewColumnStyle" v-for="item in endWorks" :key="item.name">
          <work-title :title="item.name"
                      :height="56"
                      :num="item.workList.length"
                      style="margin-bottom: 4px">
          </work-title>
          <div class="boxScroll" style="overflow-y: overlay; background-color: white;"
               :style="{'height': contentHeight()}">
            <!--<el-scrollbar style="background-color: white; height: calc(100vh - 188px)">-->
            <transition-group name="list-complete">
              <work-card v-for="work in item.workList" :key="work.id"
                         :work="work" :menu="selectMenuByWork(work)" :schshow="newSearchShow"
                         @command="handleWorkCardCommand"
                         class="card list-complete-item" :style="{'width': columnWidth + 'px'}">
              </work-card>
            </transition-group>
            <!--</el-scrollbar>-->
          </div>
        </div>

      </div>

      <add-work-dialog :visible.sync="dialog.showAddWork"></add-work-dialog>
      <detail-work-dialog :visible.sync="dialog.showDetailWork" :work-id="dialog.workId"
                          :pattern="dialog.pattern"
                          @loading="dialog.work.loading=true"></detail-work-dialog>
      <confirm-work-dialog :visible.sync="dialog.showConfirmWork" :work="dialog.work"></confirm-work-dialog>
      <dispatch-work-dialog :visible.sync="dialog.showDispatch" :work="dialog.work"></dispatch-work-dialog>
      <select-technician-dialog :visible.sync="dialog.showSelectTechnician"
                                :procedure="dialog.procedure"
                                @selectTeam="onSelectTechnician({ team: $event })"
                                @selectTechnician="onSelectTechnician({ technician: $event })">
      </select-technician-dialog>
      <interrupt-work-dialog :visible.sync="dialog.showInterruptWork" :pattern="dialog.pattern"
                             :work="this.dialog.work"></interrupt-work-dialog>
      <quality-inspect-dialog :visible.sync="dialog.showQualityInspect"
                              :work="this.dialog.work"></quality-inspect-dialog>
      <back-work-dialog :visible.sync="dialog.showBackWork" :pattern="dialog.pattern"
                              :work="this.dialog.work"></back-work-dialog>
      <!--</el-scrollbar>-->
    </div>
    <div v-else v-loading="true" style="height: calc(100vh - 200px)"></div>
  </div>
</template>

<script>
  import WorkTitle from '@/views/kanban/components/WorkTitle'
  import WorkCard from '@/views/kanban/components/WorkCard'
  import authority from '@/utils/authority'
  import DetailWorkDialog from '@/views/kanban/dialog/add-check/DetailWorkDialog'
  import ConfirmWorkDialog from '@/views/kanban/dialog/confirm-work/index'
  import { Work } from '@/store/objdef/objectDef'
  import DispatchWorkDialog from '@/views/kanban/dialog/dispatch-work/index'
  import SelectTechnicianDialog from '@/views/kanban/dialog/confirm-work/SelectTechnicianDialog'
  import InterruptWorkDialog from '@/views/kanban/dialog/interrupt-work/index'
  import { selectMenuByWork } from '@/store/modules/menu'
  import QualityInspectDialog from '@/views/kanban/dialog/quality-inspect/index'
  import BackWorkDialog from '@/views/kanban/dialog/back-work/index'
  import {
    completeDelivery,
    completeSettlement,
    dispatchWork,
    endWash,
    endWork,
    pushWork,
    rework,
    startWash,
    startWork,
    withdraw,
    stopWork,
    allOrgans
  } from '@/utils/request'
  import SearchPopover from '@/views/kanban/components/SearchPopover'
  import AddWorkDialog from '@/views/kanban/dialog/add-check/AddWorkDialog'
  import StatisticsKanban from '@/views/kanban/statistics/StatisticsKanban'
  import filterType from '@/utils/workStatusFilter'

  export default {
    name: 'KanBan',
    components: {
      StatisticsKanban,
      AddWorkDialog,
      SearchPopover,
      QualityInspectDialog,
      InterruptWorkDialog,
      SelectTechnicianDialog,
      DispatchWorkDialog,
      ConfirmWorkDialog,
      DetailWorkDialog,
      WorkCard,
      WorkTitle,
      BackWorkDialog
    },
    data () {
      return {
        OPsearchShow: null,
        searchText: null,
        columnWidth: 200,
        titleHeight: 60,
        dialog: {
          workId: '',
          work: new Work(),
          showAddWork: false,
          showDetailWork: false,
          showDispatch: false,
          showPush: false,
          showRework: false,
          readOnly: false,
          showConfirmWork: false,
          showSelectTechnician: false,
          procedure: {},
          showInterruptWork: false,
          pattern: '',
          showQualityInspect: false,
          showBackWork: false
        },
        selectMenuByWork,
        statistics: {
          onSite: 0,
          running: 0, // 正在施工，包括中断和机修
          waiting: 0,
          overdue: 0,
          delay: 0,
          reworked: 0,
          interrupted: 0,
          enterToday: 0, // 进入进场
          dueToday: 0,
          todayDelivery: 0, // 今日完成
          dueTomorrow: 0 // 明日应交
        },
        filterType,
        taskTime: '',
        taskStart: '',
        pickerOptions: {
            onPick: (time) => {
                if (time.minDate && !time.maxDate) {
                    this.taskStart = time.minDate
                }
                if (time.maxDate) {
                    this.taskStart = ''
                }
            },
            disabledDate: (time) => {
                const timeOptionRange = this.taskStart
                if (timeOptionRange) {
                    return time.getTime() !== timeOptionRange.getTime()
                }
            }
        }
      }
    },
    created () {
      this.$store.dispatch('work/getKanbanWorks', 0)
      // 提前准备数据
      this.$store.dispatch('data/kvList', 'PARTS_TYPE')
      this.$store.dispatch('data/kvList', 'Parts')
      this.$store.dispatch('partsCoe/all')
      // 根据车间权限控制是否显示全部工单操作按钮
      var that = this
      allOrgans().then(response => {
        response.data.forEach((item) => {
            if (item.type === 'WORKSHOP' && item.code === process.env.VUE_APP_CODE) {
                if (item.viewAll === 1) {
                    that.OPsearchShow = true
                } else {
                    that.OPsearchShow = false
                }
            }
        })
      })
    },
    methods: {
      DatetimeListTap () {
        console.log(this.taskTime)
        console.log(this.$store.state.work)
        this.$store.state.work.filters.estimateDeliveryTime = this.taskTime
      },
      searchTap () {
        if (this.newSearchShow) {
            this.$store.dispatch('work/getKanbanWorks', 1)
        } else {
            this.$store.dispatch('work/getKanbanWorks', 0)
        }
      },
      addWork () {
        this.dialog.showAddWork = true
      },
      handleWorkCardCommand ({ command, work }, procedureName) {
        this.dialog.workId = work.id
        this.dialog.work = work
        this.dialog.procedure = {
          id: work.procedureId,
          name: procedureName,
          dispatch2Team: work.dispatch2Team,
          type: work.procedureType
        }
        switch (command) {
          case authority.READ_WORK:
          case authority.READ_EDIT:
          case authority.READ_ADD_PARTS:
            this.dialog.pattern = command
            this.dialog.showDetailWork = true
            break

          case authority.CONFIRM_WORK:
            this.dialog.showConfirmWork = true
            break

          case authority.DISPATCH:
            this.dialog.showDispatch = true
            break

          case authority.PUSH:
            this.push(work)
            break

          case authority.STOP:
            this.dialog.work.loading = true
            stopWork(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.BACK:
            this.dialog.pattern = command
            this.dialog.showBackWork = true
            break

          case authority.START_WORK:
            this.dialog.work.loading = true
            startWork(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.END_WORK:
            this.dialog.work.loading = true
            endWork(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.WITHDRAW:
            this.dialog.work.loading = true
            withdraw(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.REWORK:
            this.dialog.work.loading = true
            rework(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.INTERRUPT:
          case authority.MACHINE_REPAIR:
            this.dialog.pattern = command
            this.dialog.showInterruptWork = true
            break

          case authority.QUALITY:
            this.dialog.showQualityInspect = true
            break

          case authority.DELIVERY:
            this.dialog.work.loading = true
            completeDelivery(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.SETTLEMENT:
            this.dialog.work.loading = true
            completeSettlement(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.START_WASH:
            this.dialog.work.loading = true
            startWash(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break

          case authority.END_WASH:
            this.dialog.work.loading = true
            endWash(work.id).catch(() => {
              this.dialog.work.loading = false
            })
            break
        }
      },
      push (work) {
        if (work.status === 'WAIT' && !work.technicianId) {
          // 提示异常
          if (work.dispatch2Team) {
            this.$alert('该工序分配到组，不支持推进!', {
              confirmButtonText: '确定'
            }).catch(() => {
            })
          } else {
            this.tipSelectTechnician(work)
          }
          return
        }
        work.loading = true
        pushWork(work.id).catch(() => {
          work.loading = false
        })
      },
      tipSelectTechnician (work) {
        this.$confirm('当前工序没有' + (work.dispatch2Team ? '工组' : '技师') + ', 是否派工', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.dialog.showSelectTechnician = true
        }).catch(() => {
        })
      },
      onSelectTechnician ({ team, technician }) {
        this.dialog.work.loading = true
        dispatchWork({
          workId: this.dialog.workId,
          procedures: [
            {
              ...this.dialog.procedure,
              teamId: team ? team.id : null,
              technicianId: technician ? technician.id : null
            }
          ]
        }).then(() => {
          pushWork(this.dialog.workId).catch(() => {
            this.dialog.work.loading = false
          })
        }).catch(() => {
          this.dialog.work.loading = false
        })
      },
      filterWorkColumn (workColumn) {
        const consultantIds = this.$store.state.work.filters.consultantIds
        const technicianIds = this.$store.state.work.filters.technicianIds
        const teamIds = this.$store.state.work.filters.teamIds
        var estimateDeliveryTime = null
        if (this.taskTime !== null) {
            estimateDeliveryTime = this.$store.state.work.filters.estimateDeliveryTime = this.taskTime
        }
        return {
          name: workColumn.name,
          workList:
            workColumn.workList.filter(work => {
              switch (this.$store.state.work.statisticsFilterType) {
                case filterType.ON_SITE_CARS:
                  if (workColumn.type === 'SETTLEMENT') return false
                  break

                case filterType.RUN_CARS:
                  if (!this.isRun(work)) return false
                  break

                case filterType.WAIT_CARS:
                  if (!this.isWait(work)) return false
                  break

                case filterType.OVERDUE_CARS:
                  if (!this.isOverdue(work)) return false
                  break

                case filterType.TODAY_CARS:
                  if (!this.isEnterToday(work)) return false
                  break

                case filterType.DELAY_CARS:
                  if (!work.delayed) return false
                  break

                case filterType.DUE_TODAY_CARS:
                  if (!this.isDueToday(work)) return false
                  break

                case filterType.REWORK_CARS:
                  if (!work.reworked) return false
                  break

                case filterType.DUE_TOMORROW_CARS:
                  if (!this.isDueTomorrow(work)) return false
                  break

                case filterType.TODAY_DELIVERY_CARS:
                  if (!(work.status === 'SETTLED' &&
                    new Date(work.deliveryTime).toDateString() === new Date().toDateString())) {
                    return false
                  }
                  break

                case filterType.INTERRUPT_CARS:
                  if (work.status !== 'INTERRUPT') return false
                  break
              }

              if (this.searchText) {
                if (
                  work.carNo.indexOf(this.searchText) === -1 &&
                  (work.ownerName || '').indexOf(this.searchText) === -1 &&
                  (work.consultantName || '').indexOf(this.searchText) === -1 &&
                  (work.technicianName || '').indexOf(this.searchText) === -1 &&
                  (work.teamName || '').indexOf(this.searchText) === -1) {
                  return false
                }
              }

              if (consultantIds.length > 0 && consultantIds.indexOf(work.consultantId) === -1) return false

              if (technicianIds.length > 0 && technicianIds.indexOf(work.technicianId) === -1) return false

              if (teamIds.length > 0 && teamIds.indexOf(work.teamId) === -1) return false

              if (estimateDeliveryTime !== undefined && estimateDeliveryTime !== null) {
                if (estimateDeliveryTime.length > 0) {
                    var sDate = null; var eDate = null; var time1 = work.estimateDeliveryTime
                    if (time1.length === 16) {
                        time1 = time1 + ':00'
                    }
                    if (estimateDeliveryTime[0].format('yyyy-MM-dd hh:mm:ss') === time1) {
                        sDate = new Date(estimateDeliveryTime[0].getTime() - 1000).format('yyyy-MM-dd hh:mm:ss')
                    } else {
                        sDate = estimateDeliveryTime[0].format('yyyy-MM-dd hh:mm:ss')
                    }
                    if (estimateDeliveryTime[1].format('yyyy-MM-dd hh:mm:ss') === time1) {
                        eDate = new Date(estimateDeliveryTime[1].getTime() + 1000).format('yyyy-MM-dd hh:mm:ss')
                    } else {
                        eDate = estimateDeliveryTime[1].format('yyyy-MM-dd hh:mm:ss')
                    }
                }
                if (sDate > time1 || time1 > eDate) {
                    return false
                }
              }

              return true
            })
        }
      },
      refresh () {
        this.$store.commit('work/RESET_WORK_LIST')
        this.$store.dispatch('work/getKanbanWorks', 0)
        this.newSearchShow = false
      },
      isRun (work) {
        return work.dispatchable && work.status.indexOf('RUN') !== -1
      },
      isWait (work) {
        if (work.status === 'WAIT_CONFIRM') return true
        return work.dispatchable && work.status.indexOf('WAIT') !== -1
      },
      isOverdue (work) {
        return new Date(work.estimateDeliveryTime).getTime() < new Date().getTime()
      },
      isEnterToday (work) {
        return new Date(work.enterTime).toDateString() === new Date().toDateString()
      },
      isDueToday (work) {
        return new Date(work.estimateDeliveryTime).toDateString() === new Date().toDateString()
      },
      isDueTomorrow (work) {
        const tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1)
        return new Date(work.estimateDeliveryTime).toDateString() === tomorrow.toDateString()
      },
      contentHeight (half) {
        if (half) {
          return this.isWin ? 'calc(50vh - 107px)' : 'calc(50vh - 99px)'
        } else {
          return this.isWin ? 'calc(100vh - 205px)' : 'calc(100vh - 188px)'
        }
      },
      contentHeight2 (half) {
        if (half) {
          return this.isWin ? 'calc(50vh - 108px)' : 'calc(50vh - 99px)'
        } else {
          return this.isWin ? 'calc(100vh - 205px)' : 'calc(100vh - 188px)'
        }
      }
    },
    computed: {
      mainViewStyle () {
        return {
          width: (24 + (this.columnWidth + 4) * (1 + this.middleWorks.length + this.endWorks.length)) + 'px'
        }
      },
      mainViewColumnStyle () {
        return {
          width: this.columnWidth + 'px'
        }
      },
      beginWork () {
        return this.filterWorkColumn(this.$store.state.work.beginWork)
      },
      middleWorks () {
        return this.$store.state.work.middleWorks.map(workColumns =>
          workColumns.map(workColumn => this.filterWorkColumn(workColumn))
        )
      },
      endWorks () {
        return this.$store.state.work.endWorks.map(workColumn =>
          this.filterWorkColumn(workColumn)
        )
      },
      isWin () {
        const platform = navigator.platform.toLowerCase()
        return (platform === 'win32') || (platform === 'windows')
      }
    },
    watch: {
      '$store.state.user.shopId' () {
        if (!this.$store.state.user.loaded) return

        this.$store.dispatch('data/kvListForce', 'ConsultantsOfShop')
        this.$store.dispatch('work/getKanbanWorks', 0)
        this.$store.dispatch('shop/updateShopInfo')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {
    margin-bottom: 6px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .boxScroll::-webkit-scrollbar{
    // width: 10px;
    display: none;
  }
  .boxScroll:hover::-webkit-scrollbar{
    width: 10px;
    height: 1px;
    display:initial;
  }
  .boxScroll:hover::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);
    background: #e5e5e5;
  }
  .boxScroll:hover::-webkit-scrollbar-track{
    -webkit-box-shadow:inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #ffffff;
  }
</style>
